import { Component, OnInit } from '@angular/core';
import {BsModalRef, ModalDirective} from 'ngx-bootstrap/modal';
import {HelperService} from "../../helper.service";
import {PropertyService}   from "../../../views/app/properties/property.service";
import {GlobalService} from "../../global.service";
import {NotificationsService, NotificationType} from "angular2-notifications";
import {TranslateService} from "@ngx-translate/core";
import Swal from "sweetalert2";
import {SupplierGlobalService} from "../../supplier-global.service";
import {NgForm} from "@angular/forms";
import {NgxSpinnerService} from "ngx-spinner";
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-rentaland-expenses-modal',
  templateUrl: './rentaland-expenses-modal.component.html',
  styleUrls: ['./rentaland-expenses-modal.component.scss']
})
export class RentalandExpensesModalComponent implements OnInit {
  rentalData: any = [];
  rentalDataClone: any = [];
  propertyRef:string = '';
  properties:any = [];
  isEdit = false;
  randomString = '';
  dataArray: any = [];
  rentalHeader: any = [];
  rentalDetails: any = [];
  dataExpenses: any = [];
  agentFee = null;
  dataMedia: any = [];
  category_type:any = [];
  supplier_id = null;
  suppliers:any = [];
  supplierListBackup = [];
  suppliersTemp = [];
  buttonDisabled = false;
  isParentModelOpen = false;
  expenseCategoryKey = null;
  tempExpenseCategories: any = [];
  modelType = null;
  rowKey = null;
  calenderAutoClose = true;
  paymentDate = null;
  isSupplierDuplicated: boolean;
  hiddenModal = false;
  constructor(
    public bsModalRef: BsModalRef,
    private helperService: HelperService,
    private propertyService : PropertyService,
    protected globalService: GlobalService,
    private notifications: NotificationsService,
    private translate: TranslateService,
    private supplierGlobalService: SupplierGlobalService,
    public spinner: NgxSpinnerService,
  ) { }

  ngOnInit(): void {
  //  this.rentalDataClone = JSON.parse(JSON.stringify(this.rentalData));
    this.getRentalHeader();
    console.log(this.rentalDataClone);
    console.log(this.rentalData);
  this.hiddenModal = false
    this.supplierGlobalService.customizeSupplierEvent.subscribe(data => {
      this.hiddenModal = false;
      this.showBackdrop()

    });

    this.supplierGlobalService.selectSupplierEvent.subscribe(data => {
      if(data['comeFrom'] == 'add-expense'){
        this.setSelectedForAddExpenseModel(data);
      }

    });
  }
  getRentalHeader() {
    this.propertyService.getPropertyRentalHeader(this.propertyRef).subscribe(response => {
     this.rentalHeader = response['header'];
     this.properties['is_custom_pick_list'] = this.rentalHeader['is_custom_pick_list'];
     this.category_type = response['category_type'];
      this.rentalData.forEach((row, key) => {
        var date = (new Date(row['rent_paid_to']));
        date.setMonth(date.getMonth() + 1);
        var date_s = this.helperService.formDateObject(date);
        this.rentalDataClone.push({
          'date_s': date_s,
          'name': this.rentalHeader['tenant'],
          'amount': row['rent_amount'],
          'media': [],
          'error_count': 0,
          'error_amount': 0,
          'randomStr': this.makeId(),
        });
        if(row['expenses_fee'].length > 0) {
          row['expenses_fee'].forEach((row2, key2)=>{

            var dateExpenses = (new Date(row2['date']));
            dateExpenses.setMonth(dateExpenses.getMonth() + 1);
            var dateExpenses_s = this.helperService.formDateObject(dateExpenses);

            this.dataArray.push({
                "payment_date": dateExpenses_s,
                "amount":row2['amount'],
                "description": row2['description'],
                "expense_category_id": "",
                "supplier_id": null,
                "business_name": "",
                "recurring_id": "",
                "next_payment_date": "",
                "pdfs": [],
                "expense_type_id": "",
                "randomStr": this.makeId(),
                "isValidateCategory": false,
                "isValidateAmount": false,
                "isValidateDate": false,
                "expense_ref": null,
                "is_error": false,
                "error_message": "",
                "expense_category": "",
                "date": row2['date'],
              }
            )
          })

        }
       // this.addRow(key, data);
      });
    }, error => {
      this.globalService.onError(error.message);
    });
  }
  async addNewRow(full_url, media_ref, file_name, type) {
    await this.makeId(10);
    var count = this.rentalData.length;
    if (count == 0) {
      this.makeId(10);
      if (this.rentalHeader['last_payment_date'] != null) {
        var date = (new Date(this.rentalHeader['last_payment_date']));;
        var current_date = new Date();
        date.setMonth(date.getMonth() + 1);
        var date_s = this.helperService.formDateObject(date);
        if (this.rentalDetails.length == 0) {
          var amount = this.rentalHeader['last_payment_amount'] == null ? null : this.rentalHeader['last_payment_amount'];
          // if (amount != null) {
          this.dataExpenses = [];
          var media = [];
          this.agentFee = (amount * this.rentalHeader['agent_fee']) / 100;
          this.makeId(10);

          this.rentalData.push({
            'date_s': date_s,
            'name': this.rentalHeader['tenant'],
            'amount': amount,
            'media': media,
            'error_count': 0,
            'error_amount': 0,
            'randomStr': this.makeId(),
            'expenses': this.dataExpenses
          });
        }
        else {
          var amount = this.rentalHeader['last_payment_amount'] == null ? null : this.rentalHeader['last_payment_amount'];
          if (amount != null) {
            this.dataExpenses = [];
            var media = [];
            this.agentFee = (amount * this.rentalHeader['agent_fee']) / 100;
            this.makeId(10);

            this.rentalData.push({
              'date_s': date_s,
              'name': this.rentalHeader['tenant'],
              'amount': amount,
              'media': media,
              'error_count': 0,
              'error_amount': 0,
              'randomStr': this.makeId(),
              'expenses': this.dataExpenses
            });


          }
        }

        // }

      }
      else {
        this.dataExpenses = [];
        var media = [];
        this.makeId(10);

        this.rentalData.push({
          'date_s': '',
          // 'name': this.rentalHeader['tenant'],
          'name': '',
          'amount': '',
          'media': media,
          'error_count': 0,
          'error_amount': 0,
          'randomStr': this.makeId(),
          'expenses': this.dataExpenses
        });
      }
    }
    else {
      var d = new Date(this.helperService.extractDateString(this.rentalData[count - 1]['rent_paid_to']));
      d.setMonth(d.getMonth() + 1);
      var date_s = this.helperService.formDateObject(d);
      this.dataExpenses = [];
      this.dataMedia = [];
      if (this.rentalData[count - 1]['rent_amount'] != null) {
        this.agentFee = (this.rentalData[count - 1]['rent_amount'] * this.rentalHeader['agent_fee']) / 100;
      }
      this.dataMedia.push({
        'full_url': full_url,
        'media_ref': media_ref,
        'file_name': file_name,
        'type': type,
        'randomStr': this.makeId()
      });
      await this.makeId(10);

      this.rentalData.push({
        'date_s': date_s,
        'name': this.rentalHeader['tenant'],
        'amount': this.rentalData[count - 1]['rent_amount'],
        'supplier_id': this.supplier_id,
        'tenant_name': '',
        'media': this.dataMedia,
        'error_count': 0,
        'error_amount': 0,
        'randomStr': this.makeId(),
        'expenses': this.dataExpenses
      });
    }

  }
  async addRow(key: number, row) {
    await this.makeId(10);
    var date = (new Date(row['rent_paid_to']));
    date.setMonth(date.getMonth() + 1);
    var date_s = this.helperService.formDateObject(date);
      var media = [];
      this.rentalDataClone.splice(key + 1, 0, {
        'date_s': date_s,
        'name': this.rentalHeader['tenant'],
        'amount': row['rent_amount'],
        'media': media,
        'error_count': 0,
        'error_amount': 0,
        'randomStr': this.makeId(),

      });
  }
  removeRecord(randomStr) {
    // console.log(randomStr);
    const index = this.rentalDataClone.findIndex(x => x.randomStr === randomStr);
    this.rentalDataClone.map((row,rowIndex)=>{
      if(index < rowIndex){
        let date = new Date(this.helperService.extractDateString(row.date_s));
        date.setMonth(date.getMonth()-1);
        row.date_s = this.helperService.formDateObject(date);
      }
    });
    this.rentalDataClone.splice(index, 1);
  }
  makeId(length=10) {
    var result = '';
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    this.randomString = result;
    return result;
  }

  validateFeild(data: any, event: any) {
    if (data['date_s'] == null) {
      data['error_count'] = 1;
    }

  }

  validateAmount(data: any, event) {
    if (data['amount'] != null) {
      data['error_amount'] = 0;
    }
    else {
      data['error_amount'] = 1;
    }
  }

  tenantChange(key: number, name: any) {
    for (let i = key; i < this.rentalDataClone.length; i++) {
      this.rentalDataClone[i]['name'] = name;
    }
  }

  amountChange(key: number, amount) {
    for (let i = key; i < this.rentalDataClone.length; i++) {
      this.rentalDataClone[i]['amount'] = amount;
    }
  }

  addExpenseCategory(addedName) {
    return { expense_category: addedName, expense_category_id: '', user_id: 'new' };
  }
  clearTooltip(key) {
    this.dataArray[key]['isValidateCategory'] = false;
  }
  clearSupplier() {
    this.suppliers = this.supplierListBackup;
    this.selectedSupplierMerge();
  }

  async changeDuplicateValue(data, key) {
    this.dataArray[key]['is_error'] = false;
    //duplicate Check
    if (data.amount != '' && data.business_name != '' && data.expense_category != '' && data.payment_date != '') {
      let date = new Date(data.payment_date);
      this.dataArray.forEach((obj, index) => {
        let date_1 = new Date(obj.payment_date);
        if (index != key) {
          if (obj['expense_category'] == data.expense_category && obj['amount'] == data.amount && obj['description'] == data.description && obj['business_name'] == data.business_name && date.getTime() === date_1.getTime()) {
            this.dataArray[key]['error_message'] = "duplicate with row " + (index + 1);
            this.dataArray[key]['is_error'] = true;
          }
        }
      });

    }
  }

  selectedSupplierMerge() {
    if(this.suppliersTemp.length > 0){
      this.suppliersTemp.forEach(element => {
        let index = this.suppliersTemp.findIndex(x => x['business_name'] == element['business_name']);
        if(index == -1){
          this.suppliers.push(element);
        }
      });
    }
  }

  getLastExpense(data, key) {
    let categoryId
    this.category_type.forEach(category => {
      if (category.expense_category == data.expense_category) {
        categoryId = category.expense_category_id;
      }
    });

    let details = {
      property_ref:this.propertyRef,
      expense_category_id: categoryId,
      supplier_temp:this.suppliersTemp
    }
    this.propertyService.getLastExpenseDetail(details).subscribe(response => {
      if (response['status'] === 200) {
        this.suppliers = response['suppliers'];
        if(response['last_expense_details'] != null){
          this.dataArray[key]['supplier_id'] = response['last_expense_details']['supplier_id'];
          this.dataArray[key]['business_name'] = response['last_expense_details']['business_name'];
          let index = this.suppliersTemp.findIndex(x => x['business_name'] == response['last_expense_details']['business_name']);
          // console.log('index', index);
          if(index == -1) {
            let state = null;
            if(response['last_expense_details']['state'] != null){
              state = '('+response['last_expense_details']['state']+')';
            }

            let data = {
              'business_name': response['last_expense_details']['business_name'],
              'supplier_id': response['last_expense_details']['supplier_id'],
              'user_supplier_id': response['last_expense_details']['supplier_id'],
              'showing_name':response['last_expense_details']['business_name'] + ' ' + state,
            }
            this.suppliersTemp.push(data);
          }
        }
      }

    }, err => {
      this.buttonDisabled = false;
      this.onError(err.message);
      this.onError(err.status);
    });
  }

  openExpenseCategoryModel(expenseCategoryModel: ModalDirective, modelType, key) {
    this.isParentModelOpen = true;
    this.expenseCategoryKey = null;
    this.tempExpenseCategories = [];
    for (let a = 0; a < this.category_type.length; a++) {
      if (this.category_type[a]['user_id'] != null) {
        this.tempExpenseCategories.push(this.category_type[a]);
      }
    }
    this.modelType = modelType;
    this.rowKey = key;
    expenseCategoryModel.show();
  }

  closeExpenseCategoryModel(expenseCategoryModel: ModalDirective) {
    this.isParentModelOpen = false;
    this.modelType = null;
    this.rowKey = null;
    this.expenseCategoryKey = null;
    this.tempExpenseCategories = [];
    expenseCategoryModel.hide();
  }
  onError(msg) {
    this.notifications.create(this.translate.instant('alert.error'), msg, NotificationType.Error, { timeOut: 3000, showProgressBar: true });
  }

  onSuccess(msg) {
    this.notifications.create(this.translate.instant('alert.success'), msg, NotificationType.Success, { timeOut: 3000, showProgressBar: true });
  }

  isDateValidation(data, key) {
    if(this.isDateValidationBoolean(data)){
      data.is_error = true;
      data.error_message = "Invalid date format";
    }
    else{
      this.dataArray[key]['isValidateDate'] = false;
    }
  }

  isDateValidationBoolean(data){
    let year = new Date(this.helperService.extractDateString(data.payment_date)).getFullYear().toString();

    if((this.helperService.extractDateString(data.payment_date)!= '' || this.helperService.extractDateString(data.payment_date)!= null) && (year.length < 4)){
      return true;
    }else {
      return false;
    }
  }

  async dateValidation(data) {
    let date = new Date();
    let selectedDate;
    if(data?.payment_date){
      selectedDate = data.payment_date ? data.payment_date : new Date(data.expense_date);
    }
    else{
      selectedDate = data
    }
    if (date < selectedDate) {

      Swal.fire({
        title: 'Are you sure?',
        text: 'You are adding an expense for a date that has not occurred yet. Do you want to continue?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'No',
        confirmButtonText: 'Yes'
      }).then((isConfirm) => {
        if (!isConfirm.value) {
          data.payment_date = null;
          this.paymentDate = null;
        }
      }, function (desmiss) { });
    }
  }

  clearTooltipAmount(event: Event,key: number) {
    event.stopPropagation();
    this.dataArray[key]['isValidateAmount'] = false;
  }

  addNewSupplier(addedName) {
    return { business_name: addedName, supplier_id: '', user_supplier_id: '',showing_name:addedName };
  }

  searchValue(event) {
    if (event['target']['value'] != "") {
      this.isSupplierDuplicated = false;
      this.globalService.getSuppliers(event['target']['value']).subscribe(response => {
          response['suppliers']?.forEach(element => {
            if (element['business_name'].toLowerCase().trim() == event['target']['value'].toLowerCase().trim()) {
              this.isSupplierDuplicated = true;
              return
            }
          });
          this.suppliers = response['suppliers'];
          this.selectedSupplierMerge();
        },
        err => {
          this.onError(err.message);

        });

    }
    else {
      this.suppliers = this.supplierListBackup;
    }
  }

  supplierChange(event, key, modelName) {
    if(event != undefined){
      if(event.user_supplier_id == ""){
        let data = {
          'comeFrom':modelName,
          'supplier_type_id':'all',
          'supplier_type':'all',
          'supplier_name':event['business_name'],
          'property_ref':this.propertyRef,
          'key':key
        }
        this.supplierGlobalService.openNewSupplierModel(data);
      }
      else {
        let details = {
          'business_name': event['business_name'],
          'user_supplier_id': event['user_supplier_id'],
          'supplier_id': event['supplier_id'],
          'showing_name': event['showing_name'],
        }
        this.suppliersTemp.push(details);
      }
    }
  }

  openSupplierListModel(key,modelName) {
    let data = {
      'comeFrom':modelName,
      'supplier_type':null,
      'property_ref':this.propertyRef,
      'key':key
    }

    this.supplierGlobalService.openSupplierListModel(data);
    this.hiddenModal = true;
    this.hideBackdrop();
  }

  private setSelectedForAddExpenseModel(data) {
    if(data['supplier'] != null){
      let agent_data = {
        'company_name': data['supplier'].company_name,
        'user_supplier_id': data['supplier'].user_supplier_id,
        'supplier_id': data['supplier'].supplier_id,
        'supplier_type':'all'
      }

      this.globalService.getSupplierList(agent_data).subscribe(res=>{
          this.suppliers = res['suppliers'];
          let showingName = data['supplier'].company_name;
          if(data['supplier'].state !=null){
            showingName = showingName + " ("+data['supplier'].state+")";
          }

          let sData = {
            'supplier_id': data['supplier'].supplier_id,
            'business_name': data['supplier'].company_name,
            'user_supplier_id': data['supplier'].user_supplier_id,
            'showing_name':showingName,
          };
          this.suppliersTemp.push(sData);
          this.supplierListBackup.push(sData);
          this.dataArray[data['key']]['business_name'] = data['supplier'].company_name;
        },
        error=>{
          this.onError(error.message);
        });

    }
    else {
      this.dataArray[data['key']]['business_name'] = null;
    }

  }


  removeExpenses(index: number) {
    this.dataArray.splice(index, 1);
  }
  addExpenseRow(){
    var dateExpenses = (new Date());
    dateExpenses.setMonth(dateExpenses.getMonth() + 1);
    var dateExpenses_s = this.helperService.formDateObject(dateExpenses);
    const formattedDate = dateExpenses.getFullYear() + '-' +
      String(dateExpenses.getMonth() + 1).padStart(2, '0') + '-' +
      String(dateExpenses.getDate()).padStart(2, '0');
    this.dataArray.push({
      "payment_date": dateExpenses_s,
      "amount":0,
      "description":'',
      "expense_category_id": "",
      "supplier_id": null,
      "business_name": "",
      "recurring_id": "",
      "next_payment_date": "",
      "pdfs": [],
      "expense_type_id": "",
      "randomStr": this.makeId(),
      "isValidateCategory": false,
      "isValidateAmount": false,
      "isValidateDate": false,
      "expense_ref": null,
      "is_error": false,
      "error_message": "",
      "expense_category": "",
      "date": formattedDate
    })
  }

  saveRentalandExpenses(form:NgForm){
    if(!form.valid){
      Swal.fire({
        icon: 'warning',
        title: 'Validation Error',
        text: 'Please check carefully. Some values are required.',
      });

      return;
    }
    var formData = [{
      "deleteExpenseRefs":null,
      "property_ref":this.propertyRef
    }];

    for (let i = 0; i < this.rentalDataClone.length; i++) {
      if (this.rentalDataClone[i]['date_s'] != null || this.rentalDataClone[i]['date_s'] != undefined) {
        let date = this.helperService.extractDateString(this.rentalDataClone[i]['date_s']);
        this.rentalDataClone[i]['date'] =  date
        this.rentalDataClone[i]['supplier_id'] = this.supplier_id;
        this.rentalDataClone[i]['business_name'] = this.rentalHeader['business_name'];
      }

    }
    this.spinner.show('expenses_modal_spinner');
    formData.push(this.rentalDataClone);
    for (let i = 0; i < this.dataArray.length; i++) {
      this.dataArray[i]['date'] = this.helperService.extractDateString(this.dataArray[i]['payment_date']);
      if (this.dataArray[i]['business_name'] != null && this.dataArray[i]['supplier_id'] == null) {
        this.dataArray[i]['supplier_id'] = this.supplier_id;
      }
    }
    var expenseData = {
      "expenses_modal_type":"New Expense",
      "property_ref":this.propertyRef,
      "data_array":this.dataArray,
    }
    forkJoin({
      api1: this.propertyService.saveRentalDetail(formData),
      api2: this.propertyService.addNewExpense(expenseData)
    }).subscribe(result => {
      this.spinner.hide('expenses_modal_spinner');
      this.globalService.onSuccess('Save Successfully !');
      this.closeModal();
      console.log("Both responses:", result.api1, result.api2);
    },error => {
      this.spinner.hide('expenses_modal_spinner');
      this.closeModal();
      this.globalService.onError(error.message);
    });

  }

  hideBackdrop() {
    const backdrop = document.querySelector('.modal-backdrop');
    if (backdrop) backdrop.classList.add('d-none');
    const container = document.querySelector('modal-container') as HTMLElement
    if (container) container.style.display = 'none';
  }

  showBackdrop() {
    const backdrop = document.querySelector('.modal-backdrop');
    if (backdrop) backdrop.classList.remove('d-none');

    const container = document.querySelector('modal-container') as HTMLElement
    if (container) container.style.display = 'block';
  }
  closeModal() {
    this.bsModalRef.hide();
  }


}
